import HLSEngine from '../HLSEngine';
export default class HLSLiveSeekEngine extends HLSEngine {
    static name = 'hlsliveseek';
    #currentTime = -1;
    #duration = 0;
    constructor(options) {
        const defaultStartPosition = -1;
        super(options, defaultStartPosition);
    }
    async seekTo(seekTime) {
        this.emit('seeking');
        const time = Math.round(seekTime);
        const wasPlaying = this.isPlaying();
        this.unload();
        this.setup();
        this.#currentTime = time;
        this.emit('timeupdate');
        const src = this.#buildUrl(time);
        this.setOptions({ src });
        await this.load();
        this.emit('seeked');
        if (wasPlaying || this.isPlaying()) {
            await this.play();
        }
    }
    getDuration = () => {
        return this.#duration || 0;
    };
    getCurrentTime = () => {
        return this.#currentTime === -1 ? 0 : this.#currentTime || 0;
    };
    async load() {
        this.on('meta', this.#onMeta);
        await super.load();
    }
    unload() {
        this.off('meta', this.#onMeta);
        super.unload();
    }
    #onMeta = (data) => {
        data.tags.forEach((tag) => {
            if (tag.key === 'EXT-X-COM-TUNEIN-AVAIL-DUR') {
                this.#duration = Number.parseInt(tag.value);
                this.#currentTime =
                    this.#currentTime === -1 ? this.#duration : this.#currentTime;
            }
        });
    };
    #buildUrl(seekTime) {
        const url = new URL(this._options.src);
        const posStart = seekTime || 1;
        url.searchParams.set('pos_start', posStart.toString());
        return url.toString();
    }
}
